import {
  CHANGE_COMPANY_SEARCH_KEYWORD,
  REQUEST_CREATE_COMPANY,
  REQUEST_SEARCH_COMPANIES,
} from 'actions/actionTypes';
import * as AppAction from 'actions/appActions';
import * as Action from 'actions/backyard/companyActions';
import * as FlashMessageAction from 'actions/flashMessageActions';
import * as API from 'apis/backyard';
import { all, call, fork, put, select, take } from 'redux-saga/effects';
import { CompanyTypes } from 'types/backyard/company';
import { createLazily } from '../index';

function* runFilterCompanies(keyword: string) {
  const { companies } = yield select((state) => state.backyard.company);
  const searchWord = keyword.toLowerCase();

  const filteredCompanies = companies.filter((company: CompanyTypes) => {
    return (
      !searchWord ||
      company.name.toLowerCase().indexOf(searchWord) > -1 ||
      company.id.toLowerCase().indexOf(searchWord) > -1
    );
  });

  yield put(Action.filterCompanies(filteredCompanies));
}

function* handleFilterCompanies() {
  const lazily = createLazily(400);
  while (true) {
    const { keyword } = yield take(CHANGE_COMPANY_SEARCH_KEYWORD);
    yield fork(lazily, runFilterCompanies, keyword);
  }
}

function* runCreateCompany(name: string, demoParam: boolean) {
  const { xCSRFToken } = yield select((state) => state.app);
  const { payload, newXCSRFToken, error } = yield call(
    API.requestCreateCompany,
    name,
    demoParam,
    xCSRFToken,
  );
  if (payload && !error) {
    yield all([
      put(AppAction.setXCSRFToken(newXCSRFToken)),
      put(Action.successCreateCompany(payload)),
      put(
        FlashMessageAction.addFlashMessage({
          type: 'success',
          message: `「${name}」を作成しました。`,
        }),
      ),
    ]);
  } else {
    yield put(Action.failureCreateCompany());
    yield put(
      FlashMessageAction.addFlashMessage({
        type: 'error',
        message: '企業の作成に失敗しました。',
      }),
    );
  }
}

function* handleCreateCompany() {
  while (true) {
    const { name, demoParam } = yield take(REQUEST_CREATE_COMPANY);
    yield fork(runCreateCompany, name, demoParam);
  }
}

// 企業一覧ページで企業を検索時に実行される
function* runRequestSearchCompanies(pageNumber: number) {
  const { searchDemoParams, searchStatus, searchKeyword } = yield select(
    (state) => state.backyard.company,
  );
  const { payload, dataSize, error, newXCSRFToken } = yield call(
    API.requestSearchCompanies,
    searchKeyword,
    searchDemoParams,
    searchStatus,
    pageNumber,
  );
  if (payload && dataSize && !error) {
    yield put(AppAction.setXCSRFToken(newXCSRFToken));
    yield put(Action.successSearchCompanies(payload, dataSize.size, pageNumber));
  } else {
    yield put(Action.failureSearchCompanies());
  }
}

function* handleSearchCompanies() {
  while (true) {
    const { pageNumber } = yield take(REQUEST_SEARCH_COMPANIES);
    yield fork(runRequestSearchCompanies, pageNumber);
  }
}

export default function* companySaga() {
  yield fork(handleFilterCompanies);
  yield fork(handleCreateCompany);
  yield fork(handleSearchCompanies);
}
